export default __webpack_public_path__ + "static/media/carrot.6508ea02.png";